import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
//import AppBar from '@material-ui/core/AppBar'
//import Toolbar from '@material-ui/core/Toolbar'
//import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import GlobalVariables from './GlobalVariables';
import './assets/css/Header.css';

import HeaderLanguageButtons from './pages/includes/HeaderLanguageButtons';


class Header extends React.Component{
  constructor(props) {
    super(props);
    this.childInstance = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.onRouteChanged(this.props, prevProps);
    }
  }

  onRouteChanged(currentProps, prevProps) {
    /*
    console.log("Header, onRouteChanged()");
    console.log(GlobalVariables);
    console.log("currentProps:");
    console.log(currentProps);
    console.log("prevProps:");
    console.log(prevProps);
    console.log(this.childInstance);
    */
    this.childInstance.updatePathsByParent(GlobalVariables, currentProps);
    //console.log("ROUTE CHANGED, currentPath: ", currentPath, "; prevPath: ", prevPath);
  }

  render(){
    return(
      HeaderJSX(this)
    );
  }
}

const HeaderJSX = (ctx) => (
  <header>
    <div>
      <Grid container spacing={0} justify="flex-end" style={{ backgroundColor: 'rgb(245, 120, 42)', height:'28px', lineHeight:'28px'}}>
        <Grid className="header-buttons-container" container spacing={0} item xs={12} sm={12}>
          <Grid className="header-buttons-container-inner" container item justify="flex-end">
            {/*}
            <Grid item>
              <div className="header-buttons-item-wrapper">
                <Button color="default" style={{ verticalAlign:'top', minHeight:'28px', fontSize:'14px', paddingTop:'4px', paddingBottom:'4px' }}>
                  <Link to='/contact-us' style={{ textDecoration: 'none', color:'#FFF' }}>
                    <span>聯絡我們</span>
                  </Link>
                </Button>
              </div>
            </Grid>
            */}
            <Grid item style={{ paddingLeft:'30px' }}>
              <div id="header-change-language-btn" className="header-buttons-item-wrapper">
                <HeaderLanguageButtons provideInstance={ instance => ctx.childInstance = instance } />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
    
    {/*}
    <nav style={{ zIndex:10 }}>
      <ul>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/roster'>Roster</Link></li>
        <li><Link to='/schedule'>Schedule</Link></li>
      </ul>
    </nav>
    */}
  </header>
)


export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js